// Internal Module Imports
import { BASE_URL_BIDDING_SERVICE } from '../../../constants';
import { HttpClient } from '../../../utils/httpClient';

const PATH = {
    getMasterBids: `/${BASE_URL_BIDDING_SERVICE}/admin/bundle-bidding/master-bids`,
    approvedCapacity: `/${BASE_URL_BIDDING_SERVICE}/admin/bundle-bidding/approved-capacity`,
    otherMarketBids: `/${BASE_URL_BIDDING_SERVICE}/admin/bundle-bidding/other-market-bids`,
    bidRequest: `/${BASE_URL_BIDDING_SERVICE}/admin/bundle-bidding/bid-request`,
    lastBid: `/${BASE_URL_BIDDING_SERVICE}/admin/bundle-bidding/last-bid`,
    createBid: `/${BASE_URL_BIDDING_SERVICE}/admin/bundle-bidding/create-bid`,
    deleteBid: `/${BASE_URL_BIDDING_SERVICE}/admin/bundle-bidding`,
    logs: `/${BASE_URL_BIDDING_SERVICE}/admin/bundle-bidding/logs`,
    createNote: `/${BASE_URL_BIDDING_SERVICE}/admin/bundle-bidding/note`,
    getNotes: `/${BASE_URL_BIDDING_SERVICE}/admin/bundle-bidding/note`,
    deleteNote: `/${BASE_URL_BIDDING_SERVICE}/admin/bundle-bidding/note`,
    panic: `/${BASE_URL_BIDDING_SERVICE}/admin/bundle-bidding/panic`,
    updatePostedEnergyBid: `/${BASE_URL_BIDDING_SERVICE}/admin/bundle-bidding/post-updated-energy-bid`,
    resultId: `/${BASE_URL_BIDDING_SERVICE}/admin/bundle-bidding/result-id`,
    fetchResult: `/${BASE_URL_BIDDING_SERVICE}/admin/bundle-bidding/fetch-result`,
    secondaryBid: `/${BASE_URL_BIDDING_SERVICE}/admin/bundle-bidding/secondary-bid`,
    getBidsForBulkBids: `/${BASE_URL_BIDDING_SERVICE}/admin/bundle-bidding/bulk-bids`,
    createBulkBids: `/${BASE_URL_BIDDING_SERVICE}/admin/bundle-bidding/bulk-bids`,
    bundleBids: `/${BASE_URL_BIDDING_SERVICE}/admin/bundle-bidding`,
    datahubCostEnergy: `/${BASE_URL_BIDDING_SERVICE}/admin/bundle-bidding/datahub-cost-energy`,
    getEnergyBidType: `/${BASE_URL_BIDDING_SERVICE}/admin/bundle-bidding/energy-bid-type`,
};

const GetMasterBids = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getMasterBids}`, { params }).then(callback).catch(error).finally(next);
};

const GetApprovedCapacity = (id, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.approvedCapacity}/${id}`).then(callback).catch(error).finally(next);
};

const GetOtherMarketsBid = (id, params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.otherMarketBids}/${id}`, { params }).then(callback).catch(error).finally(next);
};

const GetBidRequest = (id, params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.bidRequest}/${id}`, { params }).then(callback).catch(error).finally(next);
};

const GetLastBid = (id, params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.lastBid}/${id}`, { params }).then(callback).catch(error).finally(next);
};

const CreateBid = (payload, start, callback, error, next) => {
    start();
    return HttpClient.post(`${PATH.createBid}`, payload).then(callback).catch(error).finally(next);
};

const DeleteBid = (id, params, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.deleteBid}/${id}`, { params }).then(callback).catch(error).finally(next);
};

const GetLogs = (bidId, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.logs}/${bidId}`).then(callback).catch(error).finally(next);
};

const CreateNote = (bidId, payload, start, callback, error, next) => {
    start();
    return HttpClient.put(`${PATH.createNote}/${bidId}`, payload).then(callback).catch(error).finally(next);
};

const GetNotes = (bidId, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getNotes}/${bidId}`).then(callback).catch(error).finally(next);
};

const DeleteNote = (bidId, params, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.deleteNote}/${bidId}`, { params }).then(callback).catch(error).finally(next);
};

const UpdatePanicHours = (bidId, payload, start, callback, error, next) => {
    start();
    return HttpClient.put(`${PATH.panic}/${bidId}`, payload).then(callback).catch(error).finally(next);
};

const UpdatePostedEnergyBid = (payload, start, callback, error, next) => {
    start();
    return HttpClient.post(`${PATH.updatePostedEnergyBid}`, payload).then(callback).catch(error).finally(next);
};

const UpdateResultId = (id, payload, start, callback, error, next) => {
    start();
    return HttpClient.put(`${PATH.resultId}/${id}`, payload).then(callback).catch(error).finally(next);
};

const FetchResult = (bidId, start, callback, error, next) => {
    start();
    return HttpClient.put(`${PATH.fetchResult}/${bidId}`).then(callback).catch(error).finally(next);
};

const CreateSecondaryBid = (id, payload, start, callback, error, next) => {
    start();
    return HttpClient.put(`${PATH.secondaryBid}/${id}`, payload).then(callback).catch(error).finally(next);
};

const GetBidsForBulkBids = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getBidsForBulkBids}`, { params }).then(callback).catch(error).finally(next);
};

const CreateBulkBids = (payload, start, callback, error, next) => {
    start();
    return HttpClient.post(`${PATH.createBulkBids}`, payload).then(callback).catch(error).finally(next);
};

const GetBundleBids = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.bundleBids}`, { params }).then(callback).catch(error).finally(next);
};

const GetDatahubCostEnergy = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.datahubCostEnergy}`, { params }).then(callback).catch(error).finally(next);
};

const GetEnergyBidType = (bidId, params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getEnergyBidType}/${bidId}`, { params }).then(callback).catch(error).finally(next);
};

export const AdminBundleBiddingService = {
    GetMasterBids,
    GetApprovedCapacity,
    GetOtherMarketsBid,
    GetBidRequest,
    GetLastBid,
    CreateBid,
    DeleteBid,
    GetLogs,
    CreateNote,
    GetNotes,
    DeleteNote,
    UpdatePanicHours,
    UpdatePostedEnergyBid,
    UpdateResultId,
    FetchResult,
    CreateSecondaryBid,
    GetBidsForBulkBids,
    CreateBulkBids,
    GetBundleBids,
    GetDatahubCostEnergy,
    GetEnergyBidType,
};
